

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import React from 'react';

import { useToast } from '@/hooks/use-toast';

export function MuiToaster() {
  const { toasts, dismiss } = useToast();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Stack
      spacing={2}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 2000,
        width: { xs: 'calc(100% - 48px)', sm: 400 },
      }}
    >
      {toasts.map((toast) => (
        <Snackbar
          key={toast.id}
          open={toast.open}
          autoHideDuration={6000}
          onClose={() => dismiss(toast.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'relative' }} // Use Stack for positioning
        >
          <Alert
            onClose={() => dismiss(toast.id)}
            severity={toast.variant === 'destructive' ? 'error' : 'success'}
            variant="filled"
            sx={{
              width: '100%',
              boxShadow: (theme) => theme.shadows[6],
              borderRadius: 2,
              '& .MuiAlert-message': {
                width: '100%',
              },
            }}
          >
            {toast.title && <AlertTitle sx={{ fontWeight: 600 }}>{toast.title}</AlertTitle>}
            {toast.description}
            {toast.action && (
              <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
                {toast.action}
              </Stack>
            )}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
}
